<app-page-topbar [title]="'Performance'" [menu]="">
    <ng-container *ngIf="performanceOverviewComponent?.isSingleStatMode">
        <div *appDesktop class="button" (click)="performanceOverviewComponent.exportPDF()">
            <span>Export Insights</span>
            <img src="/assets/icon/icon-export-pdf-arrow.svg" alt="Export" />
        </div>
    </ng-container>
    
</app-page-topbar>

<app-performance-overview #performanceOverviewComponent>
</app-performance-overview>

